
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/depoimentos",
      function () {
        return require("private-next-pages/depoimentos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/depoimentos"])
      });
    }
  